import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useSession } from '@/components/layout/AppShell';

export function OrgSettingsPage() {
  const { org } = useSession();

  return (
    <div className="max-w-4xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold">Settings</h1>
        <p className="text-sm text-muted-foreground">Manage your organisation.</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Organisation</CardTitle>
          <CardDescription>
            <span className="font-medium">{org.name}</span> ({org.slug}) — your role: {org.role}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-1">
          <p className="text-sm">
            <Link to="/settings/members" className="underline">
              Manage members and invites →
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
